import {option, Option} from "ts-option";
import {RootState} from "../reducer/root/RootState";
import PartnerBrand from "../../model/partnerBrand/PartnerBrand";

/**
 * Gets partner brand by id.
 * @param {string} pbId Partner brand identifier to get.
 * @param {RootState} state State of the redux.
 * @returns {Option<PartnerBrand>} PartnerBrand.
 */
export function getPartnerBrand(pbId: string, state: RootState): Option<PartnerBrand> {
	return option(state.partnerBrand.partnerBrandsMap[pbId]);
}
